<div class="host-wrapper">
  <h4 *ngIf="bg.currentType === TBackgroundType.Gradient && !isDesktopRoleSimpleUser">{{trans('systems.titles.homeScreen')}}</h4>
  <div class="host" [ngClass]="[bgFull === '' ? 'bgStartEnd': 'bgFull', backgroundClass]" [style]="backgroundStyle">
    <div class="mobile-app-wrap">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
